import { createRouter, Link } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import * as TanstackQuery from "./integrations/tanstack-query/root-provider";

import { deLocalizeUrl, localizeUrl } from "./paraglide/runtime";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
export const getRouter = () => {
  const rqContext = TanstackQuery.getContext();

  const router = createRouter({
    routeTree,
    context: {
      ...rqContext,
    },

    // Paraglide URL rewrite docs: https://github.com/TanStack/router/tree/main/examples/react/i18n-paraglide#rewrite-url
    rewrite: {
      input: ({ url }) => deLocalizeUrl(url),
      output: ({ url }) => localizeUrl(url),
    },

    defaultPreload: "intent",
    scrollRestoration: true,
    defaultNotFoundComponent: () => (
      <main className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-4 text-center">
        <h1 className="text-4xl font-bold">404 — Page not found</h1>
        <p className="text-muted-foreground">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link to="/" className="text-primary underline underline-offset-4">
          Back to Toolverse home
        </Link>
      </main>
    ),
  });

  setupRouterSsrQueryIntegration({
    router,
    queryClient: rqContext.queryClient,
  });

  // Lazy-load Sentry after page load so it never blocks the initial render.
  // The Vite plugin is intentionally NOT used to avoid compile-time bundle
  // instrumentation — this keeps Sentry out of the static preload graph.
  if (!router.isServer) {
    window.addEventListener(
      "load",
      () => {
        import("@sentry/tanstackstart-react").then((Sentry) => {
          Sentry.init({
            dsn: import.meta.env.VITE_SENTRY_DSN,
            tracesSampleRate: 0.1,
            sendDefaultPii: false,
            enableLogs: true,
          });
        });
      },
      { once: true },
    );
  }

  return router;
};
